import { Injectable } from '@angular/core';
import {Item} from "../../models/Item";
import {ItemConfig} from "../../models/ItemConfig";
import {Observable, Subject} from "rxjs";
import {ItemManagerService} from "../itemManager/item-manager.service";
import {debounceTime} from "rxjs/operators";
import {GroupService} from "../groupService/group-service.service";
import {CesiumAdapterService} from "@src/app/services/cesiumAdapter21/cesium-adapter.service";


@Injectable({
  providedIn: 'root'
})

export class ActionLogService {

  private config:any[] = [];
  private _addToConfig$: Subject<any> = new Subject<any>();

  private _configUpdated: Subject<any> = new Subject<any>();
  private lastSyncChanges = {};
  get onConfigUpdated(){
    return this._configUpdated.asObservable();
  }

  protected addedItems = [];
  protected isEditing = false;
  protected actionId = 0;
  // private undoClicked:Subject<any> = new Subject<any>();

  constructor(
    private itemManager: ItemManagerService,
    private gs: GroupService,
    private view: CesiumAdapterService
  ) {
    this.initListeners();
  }

  private initListeners(){
    this.gs.addedToActionLog$.subscribe((config)=>{
      this.addToConfig(config.group, config.type, config.isGroup);
    });

    this._addToConfig$.pipe(debounceTime(500)).subscribe(()=>{
      for (let i in this.lastSyncChanges){
        if (!this.lastSyncChanges.hasOwnProperty(i)){
          continue;
        }
        let element = this.lastSyncChanges[i];
        let resultElement;

        let addElement = this.getConfigElementByType(element, 'add');
        let deleteElement = this.getConfigElementByType(element, 'remove');

        resultElement = this.getResultElement(addElement, deleteElement, element);
        let firstUpdatedElement = null;
        if (Array.isArray(element)){
          element.forEach((el)=>{
            if (Math.abs(resultElement.updateTime - el.updateTime) < 10000){
              if (!firstUpdatedElement){firstUpdatedElement = el}
              if (firstUpdatedElement.updateTime > element.updateTime){firstUpdatedElement = el}
            }
          })
        }
        if (firstUpdatedElement){
          let firstConfig = JSON.parse(firstUpdatedElement.config);
          let resultElementConfig = JSON.parse(resultElement.config);
          if (firstConfig.objects[0].position.lat!=resultElementConfig.objects[0].position.lat || firstConfig.objects[0].position.lng!=resultElementConfig.objects[0].position.lat){
            resultElementConfig.objects[0].position = firstConfig.objects[0].position;
            resultElement.config = JSON.stringify(resultElementConfig);
          }
        }
        const resultElementConfig = JSON.parse(resultElement.config);
        if (resultElementConfig.hasOwnProperty('actionId') && resultElementConfig.actionId) {
          resultElement.actionId = resultElementConfig.actionId;
          delete resultElementConfig.actionId;
          resultElement = JSON.stringify(resultElementConfig);
        }
        if (!resultElement.hasOwnProperty('actionId') || !resultElement.actionId) {
          if (resultElementConfig.hasOwnProperty('copyOf') && resultElementConfig.copyOf && this.config.length > 0) {
            const prevElement = this.config[this.config.length - 1];
            const objConfig = JSON.parse(prevElement.config);
            if (
              (resultElementConfig.copyOf == objConfig.id || resultElementConfig.copyOf == objConfig.copyOf)
              && (
                (!resultElement.updateTime && !prevElement.updateTime)
                || (resultElement.updateTime - prevElement.updateTime < 5000)
              )
            ) {
              resultElement.actionId = prevElement.actionId;
            }
          }
          if (!resultElement.hasOwnProperty('actionId') || !resultElement.actionId) {
            resultElement.actionId = this.getNextActionId();
          }
        }
        this.config.push(resultElement);
      }
      this.lastSyncChanges = {};
      this._configUpdated.next(this.config);
    });

    this.view.editStart.subscribe(() => {
      this.isEditing = true;
      this.addedItems.length = 0;
    });
    this.view.editingCancelled.subscribe(() => {
      this.isEditing = false;
      this.addedItems.length = 0;
    });
    this.itemManager.itemAdded$.subscribe(item => {
      if (this.isEditing) {
        this.addedItems.push(item);
      }
    });
  }

  private getResultElement(addElement, deleteElement, element){
    if (addElement && deleteElement){
      if (addElement.inndex < deleteElement.index){
        return {config: element[deleteElement].config, type: 'remove', isGroup: element[deleteElement].isGroup};
      }
      else{
        return (addElement.index != element.length-1) ? {config: element[element.length-1].config, type: 'add', isGroup: element[element.length-1].isGroup} :  element[element.length-1];
      }
    }
    else if (addElement && !deleteElement){
        return (addElement.index != element.length-1) ? {config: element[element.length-1].config, type: 'add', isGroup: element[element.length-1].isGroup} :  element[element.length-1];
    }
    else if(!addElement && deleteElement){
        return {config: element[element.length-1].config, type: 'remove', isGroup: element[element.length-1].isGroup};
    }
    else{
      return element[element.length-1];
    }
  }

  private getConfigElementByType(arrElement:{config, type}[], searchType:string){
    for (let i=0; i<arrElement.length; i++){
      if (arrElement[i].type == searchType){return {index: i}}
    }
    return false;
  }

  public addToConfig(config, type, isGroup?){
    let parsedConfig = JSON.parse(config);
    if (parsedConfig.id){
      if (!Array.isArray(this.lastSyncChanges[parsedConfig.id])){
        this.lastSyncChanges[parsedConfig.id] = [];
      }
      this.lastSyncChanges[parsedConfig.id].push({
        config,
        type,
        updateTime: Date.now(),
        isGroup: isGroup,
        addedItems: this.addedItems.slice()
      });
      this.addedItems.length = 0;
      this._addToConfig$.next();
    }
    return;
  }

  public getLogsCount():number{
    return this.config.length;
  }

  private getLastConfig(){
    return this.config[this.config.length-1];
  }

  private removeLastConfig(){
    this.config.pop();
  }

private addGroupFromConfig(configToMerge){
  let groupItems = configToMerge.items ? configToMerge.items.slice() : null;
  delete configToMerge.items;
  let subgroups = [];
  if (configToMerge.subgroups){
    if (Array.isArray(configToMerge.subgroups)){
      subgroups = configToMerge.subgroups.map((_subgroup)=>{
        return JSON.parse(_subgroup);
      })
    }
    else{
      subgroups = [JSON.parse(configToMerge.subgroups)];
    }
  }
  delete configToMerge.subgroups;
  this.gs.createGroup(configToMerge, (_group)=>{
    let configsToMergeItemsArr = groupItems.map((_item)=>{
      let tmpItem = JSON.parse(_item);
      tmpItem.groupId = _group.getId();
      return tmpItem;
    });

    configsToMergeItemsArr.forEach((_configToMerge)=>{
      // this.changeUndoConfigsItemStatus(_configToMerge.id, 'pending');
      let oldConfigId = _configToMerge.id;
      _configToMerge.id = null;
      this.itemManager.addItemByConfig(_configToMerge, true, oldConfigId);
    });

    subgroups.forEach((_subgroupConfig)=>{
      _subgroupConfig.id = null;
      _subgroupConfig.parent_id = _group.getId();
      this.addGroupFromConfig(_subgroupConfig);
    })
  });
}

  public undoAction(){
    if (this.getLogsCount()!=0) {
      let lastConfig = this.getLastConfig();
      let actionId = (lastConfig.hasOwnProperty('actionId') ? lastConfig.actionId : null);
      do {
        let configToMerge = null;

        try {
          configToMerge = JSON.parse(lastConfig.config);
          delete configToMerge.oldConfig;
        } catch (e) {
          throw new Error('Undo can\'t parse config ' + e);
        }

        if (lastConfig.isGroup) {
          let group = this.gs.getGroupById(configToMerge.id);

          if (lastConfig.type == 'remove') {
            // this.changeUndoConfigsItemStatus(configToMerge.id, 'pending');
            configToMerge.id = null;
            this.addGroupFromConfig(configToMerge);

            // this.itemManager.addItemByConfig(configToMerge);
          }

        } else {
          let item = this.itemManager.getItemById(configToMerge.id);

          if (lastConfig.type == 'update') {
            item.getObservable('updateOldListenerConfig').next(item.config);
            item.config.assign(configToMerge, true);
            if (item.config.hasChange()) {
              item.getSubject('skipOneActionUpdate').next(true);
              item.config.forceChange();
            }
            if (lastConfig.hasOwnProperty('addedItems')) {
              lastConfig.addedItems.forEach((addedItem: Item) => {
                let itemObject = this.itemManager.getItemById(addedItem.getId());
                if (itemObject) {
                  itemObject.removeObject(true);
                }
              });
            }
            // item.getObservable('updateObject').next(item.config);
          } else if (lastConfig.type == 'remove') {
            this.changeUndoConfigsItemStatus(configToMerge.id, 'pending');
            configToMerge.id = null;
            this.itemManager.addItemByConfig(configToMerge);
          } else if (lastConfig.type == 'add') {
            item.removeObject(true);
          }
        }
        this.removeLastConfig();
        this._configUpdated.next(this.config);

        if (this.getLogsCount() != 0) {
          lastConfig = this.getLastConfig();
        } else {
          lastConfig = null;
        }
        // this.undoClicked.next()
      } while (actionId && lastConfig && actionId === lastConfig.actionId);
    }
  }

  public changeUndoConfigsItemStatus(id, status){
    // return new Promise((resolve, reject) => {
      this.config = this.config.map((_currentConfig) => {
        let configObj = JSON.parse(_currentConfig.config);
        if (configObj.id == id){
          configObj.id = status;
          _currentConfig.config = JSON.stringify(configObj);
        }
        return _currentConfig;
      });
      // resolve(true)
    // })
  }

  public getConfigsById(id) {
    // return new Promise((resolve, reject) => {
    let resultArr = this.config.filter((_currentConfig) => {
      let configObj = JSON.parse(_currentConfig.config);
      return configObj.id == id;
    });
    return resultArr;
    // resolve(true)
    // })
  }

  public getNextActionId() {
    return (++this.actionId);
  }
}
